import actionConsts from "../constants/actions";
import urlConsts from "../constants/urls";
import netpack from "./../utils/netpack";
import { updateFirebaseData } from "./firebase";
import store from "./../store/store";

let timerCallback = null;

const updateTimer = payload => ({
	type: actionConsts.UPDATE_TIME_LEFT,
	payload: payload
});

export const setTotalSimTime = payload => ({
	type: actionConsts.GET_TOTAL_TIME,
	payload: payload
});

export const setCurrentTime = payload => ({
	type: actionConsts.GET_CURRENT_TIME,
	payload: payload
});

const timerCountdown = (userDetails, isTutorial, timeLeft, dispatch) => {
	if (this.timerCallback) {
		stopTimer();
	}
	this.timerCallback = setInterval(() => {
		if (timeLeft >= 0) {
			dispatch(updateTimer(timeLeft));
			updateFirebaseData(userDetails, isTutorial, timeLeft);
			timeLeft = timeLeft - 1;
		} else {
			//if tutorial, dont show end screen on time end
			if (!window.location.href.includes("tutorial")) {
				setGameStatusToFinished();

				//temp fix for end screen issue - set flag without waiting for game over flag
				store.dispatch({
					type: actionConsts.SET_GAME_OVER_FLAG,
					payload: true
				});
			}
			stopTimer();
		}
	}, 1000);
};

const setGameStatusToFinished = () => {
	netpack(urlConsts.GAME_COMPLETED)
		.post()
		.then(response => {
			store.dispatch({
				type: actionConsts.SET_GAME_OVER_FLAG,
				payload: true
			});
		})
		.catch(frontendError => {
			console.log(frontendError);
		});
};

export const stopTimer = () => {
	clearTimeout(this.timerCallback);
};

export const startTimer = (userId, isTutorial, timeLeft, dispatch) => {
	timerCountdown(userId, isTutorial, timeLeft, dispatch);
};



// WEBPACK FOOTER //
// /src/actions/timer.js